<template>
    <div class="business-page">
        <div class="block business-block">
            <div class="center">
                <nav class="btn-row">
                    <span class="btn" @click="openCooperation">{{lang.coop}}</span>
                </nav>
                <div class="content custom-content editor-gen" v-html="detailContent"></div>
            </div>
        </div>
        <Cooperation ref="cooperation"></Cooperation>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';
import ajax from '@/utils/ajax';
import Layout from '@/views/Layout.vue';
import Cooperation from '@/views/Cooperation.vue';
import router from '@/router';

export default {
    name: 'businessDetailBlock',
    components: {
        Layout,
        Cooperation,
    },
    props: {
        pageId: [String, Number],
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            title: '',
            detailContent: '',
            businessName: '',
        };
    },
    watch: {
        pageId() {
            this.renderNav();
        },
    },
    mounted() {
        this.renderNav();
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        renderNav() {
            const id = this.$props.pageId;
            ajax.get('/web/business/business_detail.json', {
                id,
            }).then((result) => {
                this.businessName = this.isCn ? result.data.cnBusinessName : result.data.enBusinessName;
                this.detailContent = this.isCn ? result.data.cnContent : result.data.enContent;
            }).catch(() => {});
        },
        openCooperation() {
            this.$refs.cooperation.openModel(this.businessName);
        },
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F8FAF9;
    }
    .center {
        width: 960px;
        margin: 0 auto;
        position: relative;
    }
    .btn-row {
        margin: 20px 0;
        width: 100%;
        background: #fff;
        display: flex;
        justify-content: flex-end;
        align-content: center;
        .btn {
            display: inline-block;
            padding: 0 33px 0 15px;
            background: url('../../style/right_trl.png') right 7px top 50% no-repeat #C71F4B;
            background-size: 6px 9px;
            color: #fff;
            font-size: 18px;
            height: 36px;
            line-height: 36px;
        }
    }
    .business-block {
        background: #fff;
        padding: 15px 0;
    }
</style>
